import { FundsIcon, TemperatureIcon, VoltageIcon, OrderIcon, NotifOverspeed, NotifIgnitionOff, NotifIgnitionOn, NotifDevDisconnected, NotifDevConnected, NotifBraking, NotifAcceleration, NotifGeofenceEntered, NotifGeofenceExited, NotifMotionIgnOff, NotifFallDetected } from "../Assets/images/svgs";
import { getDateEnd, getDateStart, getYearStart, manipulateDate } from "./datetime";
import PATHS from "../Routes/paths";
import { GeoFenceD1, GeoFenceD2, GeoFenceD3, GeoFenceD4, GeoFenceL1, GeoFenceL2, GeoFenceL3, GeoFenceL4, OverSpeedD1, OverSpeedD2, OverSpeedD3, OverSpeedD4, OverSpeedL1, OverSpeedL2, OverSpeedL3, OverSpeedL4, SafeParkingID1, SafeParkingID2, SafeParkingIL1, SafeParkingIL2, SafeParkingSD1, SafeParkingSD2, SafeParkingSD3, SafeParkingSL1, SafeParkingSL2, SafeParkingSL3, EmergencySosD1, EmergencySosD2, EmergencySosL1, EmergencySosL2, LocationTrackingD1, LocationTrackingD2, LocationTrackingL1, LocationTrackingL2, LocSharingD1, LocSharingD2, LocSharingD3, LocSharingL1, LocSharingL2, LocSharingL3, NavigateVehicleD1, NavigateVehicleD2, NavigateVehicleL1, NavigateVehicleL2, VehIconChangeD1, VehIconChangeD2, VehIconChangeD3, VehIconChangeL1, VehIconChangeL2, VehIconChangeL3, DailyRidePlayBackD1, DailyRidePlayBackL1, DailyRidePlayBackD2, DailyRidePlayBackL2, TripsD1, TripsD2, TripsD3, TripsD4, TripsL1, TripsL2, TripsL3, TripsL4, StatsD1, StatsL1, StatsL2, StatsD2, DocuFolderD1, DocuFolderD2, DocuFolderL1, DocuFolderL2, DevDataPlanD1, DevDataPlanL1, DevWarrD1, DevWarrL1, HelpSupportD2, HelpSupportD1, HelpSupportL1, HelpSupportL2, ServiceLogD1, ServiceLogD2, ServiceLogD3, ServiceLogL1, ServiceLogL2, ServiceLogL3 } from "../Assets/images/pngs";
import config from "../config";

export const GOOGLE_MAPS_API_KEY = config.googleMapsApiKey;
export const GOOGLE_MAPS_VERSION = '3.64';
export const ONE_DAY_MS = 86400000;

export const CO2_EMISSION_PER_KM = 0.03;
export const MANUFATURING_CO2_EMISSION_PER_KM = 0.05;

export const SETTING_ROUTES = {
  PROFILE: { idx: 1, path: PATHS.PROFILE },
  CLIENTS: { idx: 2, path: PATHS.CLIENTS },
  MODELS: { idx: 3, path: PATHS.MODELS },
};

export const ICON_MAP = {
  VOLTAGE:        <VoltageIcon />,
  TEMPERATURE:    <TemperatureIcon />,
  FUND:           <FundsIcon />,
  ORDER:          <OrderIcon />,
  GEOFENCE:       null,
  OVERSPEED:      <NotifOverspeed />,
};

export const NOTIF_TYPES = {
  101:    { label:   "Low Battery Voltage L1",         icon: ICON_MAP.VOLTAGE },
  102:    { label:   "Low Battery Voltage L2",         icon: ICON_MAP.VOLTAGE },
  103:    { label:   "High Battery Voltage L1",        icon: ICON_MAP.VOLTAGE },
  104:    { label:   "High Battery Voltage L2",        icon: ICON_MAP.VOLTAGE },
  201:    { label:   "Low Battery Temperature L1",     icon: ICON_MAP.TEMPERATURE },
  202:    { label:   "Low Battery Temperature L2",     icon: ICON_MAP.TEMPERATURE },
  203:    { label:   "High Battery Temperature L1",    icon: ICON_MAP.TEMPERATURE },
  204:    { label:   "High Battery Temperature L2",    icon: ICON_MAP.TEMPERATURE },
  301:    { label:   "New Order",                      icon: ICON_MAP.ORDER },
  302:    { label:   "Order Received",                 icon: ICON_MAP.ORDER },
  303:    { label:   "Fund Received",                  icon: ICON_MAP.FUND },
  401:    { label:   "Geofence",                       icon: ICON_MAP.GEOFENCE },
  501:    { label:   "Overspeed",                      icon: ICON_MAP.OVERSPEED },
};

export const DATE_OPTIONS = {
  YESTERDAY:    1,
  LAST_7_DAYS:  2,
  LAST_30_DAYS: 3,
  THIS_YEAR:    4,
  LIFETIME:     5,
  CUSTOM:       6,
}

export const DEFAULT_DATE = DATE_OPTIONS.YESTERDAY;

export const DATE_RANGES = {
  [DATE_OPTIONS.YESTERDAY]:      { from: getDateStart(manipulateDate({ days: -1 })),  to: getDateEnd(manipulateDate({ days: -1 })), days: 1 },
  [DATE_OPTIONS.LAST_7_DAYS]:    { from: getDateStart(manipulateDate({ days: -7 })),  to: getDateEnd(manipulateDate({ days: -1 })), days: 7 },
  [DATE_OPTIONS.LAST_30_DAYS]:   { from: getDateStart(manipulateDate({ days: -30 })), to: getDateEnd(manipulateDate({ days: -1 })), days: 30 },
  [DATE_OPTIONS.THIS_YEAR]:      { from: getYearStart(), to: Date.now() },
  [DATE_OPTIONS.LIFETIME]:       { from: 1, to: Date.now() },
  [DATE_OPTIONS.CUSTOM]:         {},
};

export const CONNECTOR_TYP = {
  "Enderson" : 1,
  "C13" : 2,
  "SB75" : 3,
  "Chagori" : 4,
}

export const CHARGING_TYP = {
  "Exiom" : 1,
  "Enigma" : 2,
  "Spnatala" : 3,
  "Other": 4,
}

export const CHARGING_TYP_REV_MAP = {
  1: "Exiom",
  2: "Enigma",
  3: "Spnatala",
  4: "Other",
}

export const CONNECTOR_TYP_REV_MAP = {
  1: "Enderson",
  2: "C13",
  3: "SB75",
  4: "Chagori",
}

export const CAN_FAULT_FEEDBACK_MAP = {
  0: "Working Fine",
  1: "Drive Fault",
  2: "Hall Sensor Fault",
  3: "High Current Fault",
  4: "High Load Fault",
  5: "High Motor Temperature Fault",
  6: "High Speed Fault",
  7: "High Temperature Fault",
  8: "High Voltage Fault",
  9: "Low Voltage Fault",
  10: "MOSFET Fault",
  11: "Motor Blocking Fault",
  12: "Motor Lost Hall Fault",
  13: "Motor Phase Loss Fault",
  14: "Motor Stuck Fault",
  15: "Throttle Fault",
}

export const PAYMENT_MODES = {
  1: "Cash",
  2: "UPI",
  3: "Cheque",
  4: "Bank Transfer"
}

export const PAYMENT_MODE_VALUES = {
  CASH: 1,
  UPI: 2,
  CHEQUE: 3,
  BANK_TRANSFER: 4
};

export const ORDER_STATUS = {
  1: "Placed",
  1.1: "PI Raised",
  2: "Cancelled",
  3: "Payment Done",
  4: "Accepted",
  5: "Added In Stock",
};

export const ORDER_STATUS_VAL = {
  "Placed": 1,
  "PI Raised": 1.1,
  "Cancelled": 2,
  "Payment Done": 3,
  "Accepted": 4,
  "Added In Stock": 5,
};

// export const ORDER_STATUS_THEME_COLORS = {
//   1: "#B28101",
//   2: "#DEC15B",
//   3: "#C55151",
//   4: "#7CC1CA",
//   5: "#7FC549",
// };

// export const ORDER_STATUS_COLORS = {
//   1: "#B28101",
//   1.1: "#FCB704",
//   2: "#DEC15B",
//   3: "#FE5151",
//   4: "#99F3FF",
//   5: "#7FC549",
// };

export const ORDER_TIMELINE_STATUSES = [
  { idx: 1, nm: "Placed" },
  { idx: 1.1, nm: "PI Raised" },
  { idx: 2, nm: "Cancelled" },
  { idx: 3, nm: "Payment Done" },
  { idx: 4, nm: "Accepted" },
  { idx: 5, nm: "Added In Stock" },
];

export const ORDER_STATUS_VALS = {
  1: { label: "Placed", color: "#B28101", themeColor: "#B28101" },
  1.1: { label: "PI Raised", color: "#FCB704", themeColor: "#FCB704" },
  2: { label: "Cancelled", color: "#DEC15B", themeColor: "#DEC15B" },
  3: { label: "Payment Done", color: "#C55151", themeColor: "#C55151" },
  4: { label: "Accepted", color: "#99F3FF", themeColor: "#7CC1CA" },
  5: { label: "Added In Stock", color: "#7FC549", themeColor: "#7FC549" },
};

export const ORDER_STATUS_PARTIALLY_ADDED = "Partially Added";

export const SHIPMENT_STATUS = {
  1: "Requested",
  2: "Shipped",
  3: "Delivered",
  4: "Cancelled",
}

export const SHIPMENT_STATUS_COLORS = {
  1: "#B28101",
  2: "#DEC15B",
  3: "#7FC549",
}

export const VENDORS = [ { value: 1, label: "Ajjas" } ];

export const ORDER_STATUS_PI_RAISED = 1.1;
export const ORDER_STATUS_CANCELLED = 2;
export const ORDER_STATUS_PAYMENT_DONE = 3;
export const ORDER_STATUS_DEVICE_ADDED_IN_STOCK = 5;
export const SHIPMENT_STATUS_REQUESTED = 2;
export const SHIPMENT_STATUS_SHIPPED = 3;
export const SHIPMENT_STATUS_CANCELLED = 4;

export const DRAWER_ACCESS_CODES = {
  DEALERS_OVERVIEW: 101,
  DEALER_MANAGEMENT: 201,
  INVENTORY_OVERVIEW: 301,
  ORDERS_OVERVIEW: 401,
  INSTALLATION_VIDEO: 501,
  SHIPMENT_OVERVIEW: 601,
  LIVE_TRACKING: 701,
  ALL_VEHICLE_STATS: 801,
  SET_ALERTS: 901,

  ANALYTICS: 1001,
  VEHICLE_ACTIVITY: 1101,
  ROUTES: 1201,
  BULK_OPERATION: 1301,
  SUB_USERS: 1401,
  NOTIFICATIONS: 1501,
  DEVICE_SUBSCRIPTION: 1601,
  LEASE: 2,
  SETTINGS: 3,
  DASHBOARD: 4,
  INVENTORY: 5,
  DEALER: 6,
  ORDERS: 7,
  ROUTE_HISTORY: 1901,
  DRIVER_MANAGEMENT: 1701,
  DRIVER_ROUTE_CHECK: 1801,
  PLANS_AND_WARRANTY: 2001,
};

export const SUBDEALERS_DES = 2;
export const SELLER_DES = 6;

export const SPN_IDS = {
  1: { nm: "Vodafone Idea" },
  2: { nm: "Vodafone Idea" },
  3: { nm: "Airtel" },
  4: { nm: "Vodafone Idea" },
}

export const PING_TEST_STATUS = {
  1: "Tested",
  2: "In Progress",
}

export const PING_TEST_STATUS_VAL = {
  "Tested": 1,
  "In Progress": 2,
}

export const MAX_RESPONSIVE_BREAKPOINT_WIDTH = 900;

export const DEVICE_INSTALLATION_TIMELINE_STATUSES = [
  { idx:1, nm: "Device Installation" },
  { idx:2, nm: "Ping Test" },
  { idx:3, nm: "Immobilisation Test" },
  { idx:4, nm: "Device Mapping" },
];

export const DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL = {
  1: { label: "Device Installation" },
  2: { label: "Ping Test" },
  3: { label: "Immobilisation Test" },
  4: { label: "Device Mapping" },
};

export const DEVICE_INSTALLATION_TIMELINE_STATUSES_NEW = [
  { idx:1, nm: "Device Installation" },
  { idx:2, nm: "Ignition Test" },
  { idx:3, nm: "Immobilisation Test" },
  { idx:4, nm: "Device Mapping" },
];

export const DEVICE_INSTALLATION_TIMELINE_STATUSES_VAL_NEW = {
  1: { label: "Device Installation" },
  2: { label: "Ignition Test" },
  3: { label: "Immobilisation Test" },
  4: { label: "Device Mapping" },
};

export const TIMELINE_STEP_NOT_COMPLETED = "#666666";
export const TIMELINE_STEP_COMPLETED = "#333333";

export const DEV_INSTALLATION_STEPS = {
  DEVICE_INSTALLATION: 1,
  PING_TEST: 2,
  IMMOBILISATION_TEST: 3,
  DEVICE_MAPPING: 4,
}

export const SHIPMENT_STATUSES = [
  { idx:1, nm: "Requested", includeInCancelTimeline: true },
  { idx:2, nm: "Shipped" },
  { idx:3, nm: "Delivered" },
  { idx:4, nm: "Cancelled", includeInCancelTimeline: true, cancel: true },
];

export const SHIPMENT_STATUSES_VAL = {
  1: { label: "Requested" },
  2: { label: "Shipped" },
  3: { label: "Delivered" },
  4: { label: "Cancelled" },
};

export const SHIPPING_STATUSES = {
  "Requested": 1,
  "Shipped": 2,
  "Delivered": 3,
  "Cancelled": 4,
}

export const RELAY_STATES = {
  "LOCKED": 1,
  "UNLOCKED": 0,
}

function generateConstants(deviceArray) {
  const DEV_TYPE_VALUES = {};
  const DEV_TYPES = {};
  const DEVICE_TYPES = [];
  const DEVICE_TYPES_VALS = {};

  deviceArray.forEach((device, index) => {
    const value = index + 1;
    const { label, price } = device;

    DEV_TYPE_VALUES[label] = value;
    DEV_TYPES[value] = label;
    DEVICE_TYPES.push({ value, label });
    DEVICE_TYPES_VALS[value] = { nm: label, price };
  });

  return { DEV_TYPE_VALUES, DEV_TYPES, DEVICE_TYPES, DEVICE_TYPES_VALS };
}

const deviceArray = [
  { label: "Ajjas (60 mAh Battery)", price: 1000 },
  { label: "Ajjas (500 mAh Battery)", price: 1500 },
  { label: "Ajjas (1200 mAh Battery) Regular Harness", price: 2000 },
  { label: "Ajjas (1200 mAh Battery) Lectrix Harness", price: 2000 },
  { label: "Ajjas IoT (1200 mAh) NO Relay", price: 2000 },
  { label: "Ajjas IoT (1200 mAh) NC Relay", price: 2000 },
];

export const { DEV_TYPE_VALUES, DEV_TYPES, DEVICE_TYPES, DEVICE_TYPES_VALS } = generateConstants(deviceArray);
export const RIDING_SCORE_COLORS = {
  "Excellent" : "#6AB258",
  "Average": "#F9793E",
  "Poor": "#D34747",
}

export const OVERSPEED_TRIGGER_TYPE = 1;
export const GEOFENCE_TRIGGER_TYPE = 2;

export const SHARING_PATH = "/tlshared";

export const DEVICE_HWTYP_VALUES = {
  1: "Wired",
  2: "Wireless",
  3: "Lite",
}

export const DEVICE_HWTYPS = {
  "Wired": 1,
  "Wireless": 2,
  "Lite": 3,
}

export const FUEL_TYPES = {
  1: "Petrol",
  2: "Diesel",
  3: "Electric",
  4: "CNG",
  5: "CNG+Petrol",
};

export const LOGIN_REDIRECT_PATHS = {
  101: PATHS.DEALERS_OVERVIEW,
  201: PATHS.DEALERS_OVERVIEW,
  301: PATHS.INVENTORY_OVERVIEW,
  401: PATHS.ORDERS_OVERVIEW,
  501: PATHS.INSTALLATION_VIDEO,
  601: PATHS.SHIPMENT_OVERVIEW,
  701: PATHS.LIVE_TRACKING,
  801: PATHS.ALL_VEHICLE_STATS,
  901: PATHS.SET_ALERTS,
  1001: PATHS.ANALYTICS,
  1101: PATHS.VEHICLE_ACTIVITY,
  1201: PATHS.VIEW_ROUTES,
  1301: PATHS.BULK_OPERATIONS,
  1401: PATHS.SUB_USERS,
  1501: PATHS.NOTIFICATIONS,
  1601: PATHS.DEVICE_SUBSCRIPTION,
  1801: PATHS.DRIVER_ROUTE_CHECK,
  1901: PATHS.ROUTE_HISTORY,
  2001: PATHS.PLANS_AND_WARRANTY,
}
export const RELAY_TEST_STATUS_VAL = 3;

export const SPN_IDS_MAP = {
  1: "Vodafone Idea",
  2: "Vodafone Idea",
  3: "Airtel",
  4: "Vodafone Idea",
};

export const SPEED_ALERTS_TITLE = "Speed Alerts";
export const OVERSPEEd_NOTIFICATION_TYPE = 201;
export const GEOFENCE_NOTIFICATION_TYPE = 202;
export const SEUDO_EVENT_NOTIFICATION_TYPE = 1001;

export const VEHICLE_TYPES = {
  1: "Two wheeler",
  2: "Four wheeler",
  3: "Auto rickshaw",
  4: "Heavy vehicle",
  5: "Others",
  6: "Public Transport",
  7: "Cycle",
  8: "No Vehicle",
  9: "Electric Vehicle (EV)",
};

export const VEHICLE_ICON_URLS = {
  "Two wheeler": {
    NORMAL: "https://img.ajjas.com/images/web_assets/BIKE_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/BIKE_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/BIKE_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/BIKE_POWER_OFF.png",
  },
  "Four wheeler": {
    NORMAL: "https://img.ajjas.com/images/web_assets/CAR_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/CAR_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/CAR_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/CAR_POWER_OFF.png",
  },
  "Heavy vehicle": {
    NORMAL: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/HEAVY_VEH_POWER_OFF.png",
  },
  "Others": {
    NORMAL: "https://img.ajjas.com/images/web_assets/OTHER_NORMAL.png",
    MOTION: "https://img.ajjas.com/images/web_assets/OTHER_MOTION.png",
    IGNITION: "https://img.ajjas.com/images/web_assets/OTHER_IGNITION.png",
    POWER_OFF: "https://img.ajjas.com/images/web_assets/OTHER_POWER_OFF.png",
  }
}

export const BIKE_NORMAL_ICON = "https://img.ajjas.com/images/web_assets/BIKE_NORMAL.png";
export const VEHICLE_TYPE_BIKE = 1;

export const MOBILE_OS = {
  ANDROID: "Android",
  IOS: "iOS",
}

export const AJJAS_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.ajjas";

export const AJJAS_APP_STORE_LINK = "https://apps.apple.com/in/app/ajjas/id1383420207";
export const ANALYTICS_DASHBOARD_ACC_CODE = 1001;

export const VEH_FIL_CT = [
  { idx: 1, label: "Less than", value: 0 },
  { idx: 2, label: "More than", value: 1 },
  { idx: 3, label: "Less than equals", value: 2 },
  { idx: 4, label: "More than equals", value: 3 },
]
export const MAP_REDIRECT_URL = "https://maps.google.com"
export const GOOGLE_MAPS_NAV_URL = "https://www.google.com/maps/dir/?api=1&destination="

export const VALID_IMEI_LENGTH = 15;
export const VALID_CHASSIS_LENGTH = 17;
export const VALID_SHIP_ID_LENGTH = 5;
export const VALID_ORDER_ID_LENGTH = 4;
export const VALID_NEW_ORDER_ID_LENGTH = 5;

export const PING_TEST_STEPS = {
  IGN_SWITCH: "ignSwitch",
  IN_PROGRESS: "inProgress",
  RATED_VOLT_INP: "ratedVoltInput",
  UNABLE_DETECT_IGN: "unableToDetectIgn",
  IGN_DETECTED: "ignDetected",
  RELAY_TEST: "relayTest"
}

export const IGNITION_STATE = {
  OFF: 0,
  ON: 1,
};

export const GSM_SIGNAL_LEVELS = {
  STRONG: "Strong",
  GOOD: "Good",
  BAD: "Bad",
}

export const UNSET_REASON_KEY = "unstRsn";

export const LIVE_TRACKING_ACC_CODE = 701;

export const WEB_APP_PATHS = [ PATHS.LIVE_TRACKING, PATHS.ANALYTICS, PATHS.VEHICLE_ACTIVITY, PATHS.SET_ALERTS, PATHS.VIEW_ROUTES, PATHS.ALL_VEHICLE_STATS, PATHS.SPECIFIC_DEVICE, PATHS.DEVICES, PATHS.DRIVER_ROUTE_CHECK, PATHS.ROUTE_HISTORY ];

export const BULK_OPERATION_TYPES = {
  1: "Immobilise Vehicles",
  2: "Mobilise Vehicles",
};

export const BULK_OPR_STATUS_TYPES = {
  1: "Pending",
  2: "Done",
  3: "Already In State",
  4: "Cancelled",
  5: "Not Found",
};

export const BULK_OPR_STATUS_VALS = {
  DONE: 2,
  ALREADY_IMMOBILISED: 3,
};

export const SUB_USER_FEATURES = [
  { idx: 1, value: 701, label: "Live Tracking" },
  { idx: 2, value: 801, label: "Staistics" },
  { idx: 3, value: 901, label: "Set Alerts" },
];

export const VOLTAGE_LEVEL_MAP = {
  0: "No Power (shutdown)",
  1: "Extremely Low Battery (not enough for calling or sending text messages, etc.)",
  2: "Very Low Battery (Low Battery Alarm)",
  3: "Low Battery (can be used normally)",
  4: "Medium",
  5: "High",
  6: "Very High"
};

export const BLOOD_GROUP_TYPES = {
  1: "A+",
  2: "B+",
  3: "AB+",
  4: "O+",
  5: "A-",
  6: "B-",
  7: "AB-",
  8: "O-",
}

export const VEH_TYPE_NAMES = {
  1: "2 Wheeler",
  2: "4 Wheeler",
  3: "3 Wheeler",
  4: "Heavy Vehicle",
  5: "Other",
  6: "Public Transport",
  7: "Cycle",
  8: "No Vehicle",
};

export const CS_IVR_NUMBER = "7948541340";

export const CONTACT_TYPES = {
  NOTIFICATION: 1,
  CALL_USER: 2,
  CALL_EMERGENCY: 3,
}

export const CS_BUY_NOW_LINK = "https://www.amazon.in/dp/B0FKH6SKFZ?ref=cm_sw_r_cp_ud_dp_3E0WEX1VRNA1R74FNB8C_2&ref_=cm_sw_r_cp_ud_dp_3E0WEX1VRNA1R74FNB8C_2&social_share=cm_sw_r_cp_ud_dp_3E0WEX1VRNA1R74FNB8C_2";
export const VEH_TYPES = {
  TWO_WHEELER: 1,
  THREE_WHEELER: 2,
  FOUR_WHEELER: 3,
  HEAVY_VEHICLE: 4,
  OTHER: 5,
  PUBLIC_TRANSPORT: 6,
  CYCLE: 7,
  NO_VEHICLE: 8,
};

export const NOTIF_TYPE_VALS = {
  1: { nm: "Motion", icon: <NotifMotionIgnOff />, text: "detected motion" },
  2: { nm: "Ignition Off", icon: <NotifIgnitionOff />, text: "Ignition Turned OFF" },
  3: { nm: "Ignition On", icon: <NotifIgnitionOn />, text: "Ignition Turned ON" },
  4: { nm: "Fall (Ignition On)", icon: <NotifFallDetected />, text: "detected a fall with ignition ON" },
  5: { nm: "Fall (Ignition Off)", icon: <NotifFallDetected />, text: "detected a fall with ignition OFF" },
  6: { nm: "Device Disconnected", icon: <NotifDevDisconnected />, text: "device disconnected from power supply" },
  // 7: { nm: "RELAY_OFF", icon: null, text: "" },
  // 8: { nm: "RELAY_ON", icon: null, text: "" },
  9: { nm: "Device Connected", icon: <NotifDevConnected />, text: "device connected to power supply" },
  // 14: { nm: "VIBRATION", icon: null, text: "" },
  // 101: { nm: "CUSTOM_NOTIF", icon: null, text: "" },
  251: { nm: "Sudden Braking", icon: <NotifBraking />, text: "detected Sudden Braking" },
  252: { nm: "Harsh Acceleration", icon: <NotifAcceleration />, text: "detected Harsh Acceleration" },
  // 253: { nm: "SHARP_TURN", icon: null, text: "" },
  // 254: { nm: "OVERSPEED", icon: null, text: "" },
  201: { nm: "Speed Alert", icon: <NotifOverspeed />, text: (spd, hint) => `has exceeded Overspeed Limit of ${spd} km/hr ${hint || ""}` },
  202: { nm: "Geo Fence", icon: { true: <NotifGeofenceEntered />, false: <NotifGeofenceExited /> }, text: (igf, nm) => `has ${igf ? "entered" : "exited"} “${nm}" Geofence` },
  // 204: { nm: "SAFE_PARK", icon: null, text: "" },
  // 1001: { nm: "PSEUDO_EVT", icon: null, text: "" },
  // 2001: { nm: "WL_BATTERY_LEV", icon: null, text: "" },
  // 2004: { nm: "FIRST_EVT_OF_DAY", icon: null, text: "" },
  // 911: { nm: "SOS_NOTIF", icon: null, text: "" },
  // 900: { nm: "START_EVT", icon: null, text: "" },
}

export const NOTIFS_DEFAULT_LIMIT = 50;

export const LOC_OPTIONS = {
  APPLY_EVERYWHERE: 1,
  INSIDE: 2,
  OUTSIDE: 3,
}

export const AJJAS_APP_THEMES = {
  AMBER: "Amber",
  OCEAN: "Ocean",
};

const createThemeImages = (imagesByTheme) => (theme) => {
  return imagesByTheme[theme] || [];
}

export const FEATRUE_INTRO_IMAGES = {
  a1: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [GeoFenceD1, GeoFenceD2, GeoFenceD3, GeoFenceD4],
    [AJJAS_APP_THEMES.OCEAN]: [GeoFenceL1, GeoFenceL2, GeoFenceL3, GeoFenceL4],
  }),
  a2: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [OverSpeedD1, OverSpeedD2, OverSpeedD3, OverSpeedD4],
    [AJJAS_APP_THEMES.OCEAN]: [OverSpeedL1, OverSpeedL2, OverSpeedL3, OverSpeedL4],
  }),
  a3: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [SafeParkingID1, SafeParkingID2, SafeParkingSD1, SafeParkingSD2, SafeParkingSD3],
    [AJJAS_APP_THEMES.OCEAN]: [SafeParkingIL1, SafeParkingIL2, SafeParkingSL1, SafeParkingSL2, SafeParkingSL3],
  }),
  a4: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [EmergencySosD1, EmergencySosD2],
    [AJJAS_APP_THEMES.OCEAN]: [EmergencySosL1, EmergencySosL2],
  }),

  b1: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [LocationTrackingD1, LocationTrackingD2],
    [AJJAS_APP_THEMES.OCEAN]: [LocationTrackingL1, LocationTrackingL2],
  }),
  b2: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [LocSharingD1, LocSharingD2, LocSharingD3],
    [AJJAS_APP_THEMES.OCEAN]: [LocSharingL1, LocSharingL2, LocSharingL3],
  }),
  b3: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [NavigateVehicleD1, NavigateVehicleD2],
    [AJJAS_APP_THEMES.OCEAN]: [NavigateVehicleL1, NavigateVehicleL2],
  }),
  b4: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [VehIconChangeD1, VehIconChangeD2, VehIconChangeD3],
    [AJJAS_APP_THEMES.OCEAN]: [VehIconChangeL1, VehIconChangeL2, VehIconChangeL3],
  }),

  c1: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [DailyRidePlayBackD1, DailyRidePlayBackD2],
    [AJJAS_APP_THEMES.OCEAN]: [DailyRidePlayBackL1, DailyRidePlayBackL2],
  }),
  c2: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [TripsD1, TripsD2, TripsD3, TripsD4],
    [AJJAS_APP_THEMES.OCEAN]: [TripsL1, TripsL2, TripsL3, TripsL4],
  }),
  c3: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [StatsD1, StatsD2],
    [AJJAS_APP_THEMES.OCEAN]: [StatsL1, StatsL2],
  }),

  d1: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [DocuFolderD1, DocuFolderD2],
    [AJJAS_APP_THEMES.OCEAN]: [DocuFolderL1, DocuFolderL2],
  }),
  d2: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [DevDataPlanD1],
    [AJJAS_APP_THEMES.OCEAN]: [DevDataPlanL1],
  }),
  d3: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [DevWarrD1],
    [AJJAS_APP_THEMES.OCEAN]: [DevWarrL1],
  }),
  d4: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [HelpSupportD1, HelpSupportD2],
    [AJJAS_APP_THEMES.OCEAN]: [HelpSupportL1, HelpSupportL2],
  }),
  d5: createThemeImages({
    [AJJAS_APP_THEMES.AMBER]: [ServiceLogD1, ServiceLogD2, ServiceLogD3],
    [AJJAS_APP_THEMES.OCEAN]: [ServiceLogL1, ServiceLogL2, ServiceLogL3],
  }),
};

export const MAX_SPEED_LIMIT = 250;

export const SUBSCRIPTION_EXPIRED_DAYS_THRESHOLD = 0;
export const SUBSCRIPTION_SIM_BLOCK_WINDOW_DAYS = 90;
export const SUBSCRIPTION_SIM_BLOCK_THRESHOLD_DAYS_LEFT = -SUBSCRIPTION_SIM_BLOCK_WINDOW_DAYS;
export const SUBSCRIPTION_SIM_BLOCK_WARNING_DAYS = 15;
export const SUBSCRIPTION_SIM_BLOCK_WARNING_THRESHOLD_DAYS_LEFT = -SUBSCRIPTION_SIM_BLOCK_WARNING_DAYS;

export const BULK_WARRANTY_EXTENSION_PRICE = 365;
export const BULK_WARRANTY_MID_TIER_PRICE = 499;
export const BULK_WARRANTY_RENEWAL_PRICE = 730;

export const RAZORPAY_SDK = 'https://checkout.razorpay.com/v1/checkout.js';
